import { query, request } from '@/utils/request';

// 预算科目列表
export async function getBudgetAccountSubjectList(params) {
  const currentYear = new Date().getFullYear();
  const data = {
    year: currentYear,
    ...params,
  };
  return query('/zlb/budget/account/subject/list-tree', {
    data,
    method: 'POST',
  });
}

// 编辑预算科目
export async function editBudgetAccountSubject(data) {
  return query('/zlb/budget/account/subject/edit', {
    data,
    method: 'POST',
  });
}

// 科目打标-选择科目确定
export async function makeTagBudgetAccountSubject(data) {
  return query('/zlb/budget/account/subject/make-tag', {
    data,
    method: 'POST',
  });
}

// 移除打标-删除
export async function removeTagBudgetAccountSubject(data) {
  return query('/zlb/budget/account/subject/move-tag', {
    data,
    method: 'POST',
  });
}

// 关联部门经济科目分类
export async function updateDepartmentEconomyClassify(data) {
  return query('/zlb/budget/account/subject/update-department-economy-classify', {
    data,
    method: 'POST',
  });
}

// 其他资金指标-列表
export async function getOtherFundQuotaPageList(data) {
  return query('/zlb/budget/other-fund/page', {
    data,
    method: 'POST',
  });
}
// 其他资金指标-单位预算编码
export async function getOtherFundQuotaOrgCode(params) {
  return query('/zlb/budget/other-fund/org-code', {
    params,
  });
}

// 其他资金指标-删除
export async function deleteOtherFundQuota(data) {
  return query('/zlb/budget/other-fund/delete', {
    data,
    method: 'POST',
  });
}

// 其他资金指标-详情
export async function getOtherFundQuotaDetail(data) {
  return query('/zlb/budget/other-fund/detail', {
    data,
    method: 'POST',
  });
}

// 其他资金指标-保存
export async function saveOtherFundQuota(data) {
  return query('/zlb/budget/other-fund/save', {
    data,
    method: 'POST',
  });
}

// 其他资金指标-编辑
export async function editOtherFundQuota(data) {
  return query('/zlb/budget/other-fund/edit', {
    data,
    method: 'POST',
  });
}

// 其他资金项目-列表
export async function getOtherFundProjectPageList(data) {
  return query('/zlb/budget/other-fund/project/page', {
    data,
    method: 'POST',
  });
}

// 其他资金项目-详情
export async function getOtherFundProjectProjectDetail(data) {
  return query('/zlb/budget/other-fund/project/detail', {
    data,
    method: 'POST',
  });
}

// 其他资金项目-删除
export async function deleteOtherFundProject(data) {
  return query('/zlb/budget/other-fund/project/delete', {
    data,
    method: 'POST',
  });
}

// 其他资金项目-创建
export async function createOtherFundProject(data) {
  return query('/zlb/budget/other-fund/project/create', {
    data,
    method: 'POST',
  });
}

// 其他资金项目-编辑
export async function editOtherFundProject(data) {
  return query('/zlb/budget/other-fund/project/edit', {
    data,
    method: 'POST',
  });
}

// 其他资金项目类型-列表
export async function getOtherFundProjectTypePageList(data) {
  return query('/zlb/budget/other-fund/project-type/page', {
    data,
    method: 'POST',
  });
}

// 其他资金项目类型-删除
export async function deleteOtherFundProjectType(data) {
  return query('/zlb/budget/other-fund/project-type/delete', {
    data,
    method: 'POST',
  });
}

// 其他资金项目类型-创建
export async function createOtherFundProjectType(data) {
  return query('/zlb/budget/other-fund/project-type/create', {
    data,
    method: 'POST',
  });
}

// 其他资金项目类型-编辑
export async function editOtherFundProjectType(data) {
  return query('/zlb/budget/other-fund/project-type/edit', {
    data,
    method: 'POST',
  });
}

// 其他资金项目类型-详情
export async function getOtherFundProjectTypeDetail(data) {
  return query('/zlb/budget/other-fund/project-type/detail', {
    data,
    method: 'POST',
  });
}

// 其他资金项目类型-下拉列表
export async function getOtherFundProjectTypeDownList(data) {
  return query('/zlb/budget/other-fund/project-type/tree', {
    data,
    method: 'POST',
  });
}

// 其他资金-导入任务提交
export async function submitZlbBudgetImportPost(data) {
  return query('/zlb/budget/other-fund/project/import/submit', {
    data,
    method: 'POST',
  });
}

// 其他资金-获取导入结果
export async function resultZlbBudgetImportPost(params) {
  return query('/zlb/budget/other-fund/project/import/result', {
    params,
  });
}

// 其他资金-获取模板地址
export async function getTemplateZlbBudgetImportGet(params) {
  return query('/zlb/budget/other-fund/project/import/template', {
    params,
  });
}

// 保存台账登记
export async function saveAccountRegister(data) {
  return query('/zlb/api/financial/ledger/save', {
    data,
    method: 'POST',
  });
}

// 查询台账登记
export async function queryAccountRegister(data) {
  return query('/zlb/api/financial/ledger/query', {
    data,
    method: 'POST',
  });
}

// 提交导出任务
export async function submitTask(data) {
  return query('/zlb/api/financial/common/export', {
    data,
    method: 'POST',
  });
}

// 解析任务
export async function queryTask(data) {
  return query(`/zlb/api/financial/common/export-result/${data.serialCode}`);
}

// 提交导出任务
export async function submitFundsInstructionsTask(data) {
  return query('/zlb/api/search/common/export', {
    data,
    method: 'POST',
  });
}

// 解析任务
export async function queryFundsInstructionsTask(data) {
  return query(`/zlb/api/search/common/export-result/${data.serialCode}`);
}

// 搜索台账往来单位名称
export async function getFinancialLedgerByName(data) {
  return query('/zlb/api/financial/ledger/search-counterparty-name', {
    data,
    method: 'POST',
  });
}

export async function getLedgerList(data) {
  return query('/zlb/api/financial/ledger/list', {
    data,
    method: 'POST',
  });
}

// 获取租户下属机构
export async function getTenantOrgList(params) {
  return query('/zlb/api/expense/common/tenant-org/query', { params });
}

export async function getUnitOtherFundsFormList(data) {
  return query('/zlb/api/search/page/unit-other-funds', {
    data,
    method: 'POST',
  });
}

export async function getFundsInstructionsList(data) {
  return query('/zlb/api/search/page/unit-other-funds-directive', {
    data,
    method: 'POST',
  });
}

// 获取账户数据
export async function getAccountByCode(data) {
  return query(`/zlb/api/pay/bankCard/detail/${data.accountCode}`);
}

// 保存其他资金单据
export async function saveOtherFundsForm(data) {
  return query('/zlb/api/expense/rest/save', {
    data,
    method: 'POST',
  });
}

// 提交其他资金单据
export async function submitOtherFundsForm(data) {
  return query('/zlb/api/expense/rest/submit', {
    data,
    method: 'POST',
  });
}

// 其他资金单据详情
export async function getOtherFundsDetail(data) {
  return query('/zlb/api/expense/rest/detail', {
    data,
    method: 'POST',
  });
}

// 其他资金单据删除
export async function deleteOtherFunds(data) {
  return query('/zlb/api/expense/rest/delete', {
    data,
    method: 'POST',
  });
}

// 审核前校验
export async function validateCheck(data) {
  return query('/zlb/api/expense/rest/check', {
    data,
    method: 'POST',
  });
}

// 审核前校验
export async function cancelRestPay(data) {
  return query('/zlb/api/expense/rest/pay/cancel', {
    data,
    method: 'POST',
  });
}

// 批量支付
export async function batchPay(data) {
  return query('/zlb/api/expense/rest/pay/apply', {
    data,
    method: 'POST',
  });
}

// export const getGroupAccountSubject = () => {
//   return query('/zlb/api/expense/expense-form/getGroupAccountSubject');
// };

// 回单登记
export const submitBankReceipt = data => {
  return query('/zlb/api/expense/rest/bank/receipt/register', {
    data,
    method: 'POST',
  });
};

// 查询单位集团子账户对应的科目
export const getGroupAccountSubject = params => {
  return query('/zlb/budget/account/subject/list/group-account-subject', {
    params,
  });
};

// 子账户打印信息
export const getChildAccountPrintInfo = params => {
  return query('/zlb/api/expense/rest/cheque/print', { params });
};
// 台账删除
export async function removeLedger(data) {
  return query('/zlb/api/financial/ledger/remove', {
    data,
    method: 'POST',
  });
}
// 结转科目
export async function accountSubjectConfigOverYear(data) {
  return query('/zlb/budget/account/subject/copy-subject-config-over-year', {
    data,
    method: 'POST',
  });
}
// 是否可以结转
export const CheckCopyAccountSubject = async params => {
  return query('/zlb/budget/account/subject/check-copy', {
    method: 'GET',
    params,
  });
};
//查询台账批量导入模板
export const getLedgerTemplate = async params => {
  return request('/zlb/api/financial/common/import/template-query', {
    method: 'GET',
    params,
  });
};
//查询台账导入结果
export async function queryLedgerImportResult(data) {
  return query('/zlb/api/financial/common/import-result', {
    data,
    method: 'POST',
  });
}
//查询台账导入结果
export async function confirmImport(data) {
  return request('/zlb/api/financial/common/import/confirm-result', {
    data,
    method: 'POST',
  });
}
// 台账批量导入任务提交
export async function submitLedgerTask(data) {
  return query('/zlb/api/financial/common/import/submit', { method: 'POST', data });
}
// 使用模板
export async function useTemplate(data) {
  return query('/zlb/api/expense/small-transfer/detail/template/apply', { method: 'POST', data });
}
